import { render } from "./PopupDeleteUserContract.vue?vue&type=template&id=2091ac40&scoped=true"
import script from "./PopupDeleteUserContract.vue?vue&type=script&lang=js"
export * from "./PopupDeleteUserContract.vue?vue&type=script&lang=js"

import "./PopupDeleteUserContract.vue?vue&type=style&index=0&id=2091ac40&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2091ac40"]])

export default __exports__